import type { Session } from "@supabase/supabase-js";
import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
  type ReactNode,
} from "react";
import { supabase } from "./lib/supabase";

interface ContextoSesion {
  sesion: Session | null;
  cargando: boolean;
  salir: () => Promise<void>;
}

const Contexto = createContext<ContextoSesion>({
  sesion: null,
  cargando: true,
  salir: async () => {},
});

export function ProveedorSesion({ children }: { children: ReactNode }) {
  const [sesion, setSesion] = useState<Session | null>(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setSesion(data.session);
      setCargando(false);
    });

    // Supabase renueva el token solo; este listener mantiene el estado al día
    // sin que haya que refrescar la página cuando caduca.
    const { data } = supabase.auth.onAuthStateChange((_evento, nueva) => {
      setSesion(nueva);
    });

    return () => data.subscription.unsubscribe();
  }, []);

  const valor = useMemo<ContextoSesion>(
    () => ({
      sesion,
      cargando,
      salir: async () => {
        await supabase.auth.signOut();
      },
    }),
    [sesion, cargando],
  );

  return <Contexto.Provider value={valor}>{children}</Contexto.Provider>;
}

export const useSesion = (): ContextoSesion => useContext(Contexto);
